// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"styles__fieldset___2o6Gt","legend":"styles__legend___3RUgx","double-columns":"styles__double-columns___XZWHn","columns":"styles__columns___3WTr3"};